export interface Category {
  key: string;
  name: string;
  path: string;
  description: string;
  icon: string;
  tagline: string;
}

export const categories: Category[] = [
  {
    key: 'news',
    name: '娱乐新闻',
    path: '/category/news',
    description: '91吃瓜娱乐新闻频道，第一时间发布影视综艺八卦动态',
    icon: 'ri-newspaper-line',
    tagline: '影视 · 综艺 · 行业动态',
  },
  {
    key: 'star',
    name: '明星动态',
    path: '/category/star',
    description: '追踪明星最新动态，剧组探班、巡演官宣、时尚活动一站掌握',
    icon: 'ri-star-smile-line',
    tagline: '艺人 · 剧组 · 巡演',
  },
  {
    key: 'hot',
    name: '网络热点',
    path: '/category/hot',
    description: '全网热点事件追踪与解读，热搜背后的来龙去脉一次看懂',
    icon: 'ri-fire-line',
    tagline: '热搜 · 事件 · 讨论',
  },
];

export const getCategoryMeta = (key: string): Category | undefined =>
  categories.find((item) => item.key === key);